import { render, staticRenderFns } from "./CardPromotion.vue?vue&type=template&id=a2559d5c&scoped=true&lang=pug"
import script from "./CardPromotion.vue?vue&type=script&lang=js"
export * from "./CardPromotion.vue?vue&type=script&lang=js"
import style0 from "./CardPromotion.vue?vue&type=style&index=0&id=a2559d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2559d5c",
  null
  
)

export default component.exports